import * as _ from 'lodash'
import {ALL_FILES_UPLOADED, FILE_UPLOADED, FileUploadResult, UPLOAD_FILES} from "./file-upload-types";
import Axios, {AxiosResponse} from "axios";
import {uploadUrl} from "../helpers/UrlHelper";
import {AlbumInfo, ServiceError} from "../models/responses";
import MediaItem from "../models/media-item";

export function doFilesUpload(files: File[], album: AlbumInfo): FileUploadResult<any> {
    return (dispatch, getState) => {
        const file = _.head(files)
        const restFiles = _.tail<File>(files)

        if (file) {
            dispatch({
                type: UPLOAD_FILES,
                files: restFiles,
                activeFile: file,
                album: album
            })
            dispatch(doFileUpload())
        } else {
            dispatch({
                type: ALL_FILES_UPLOADED
            })
        }

    }
}

export function doFileUpload(): FileUploadResult<any> {
    return (dispatch, getState) => {
        const file = getState().uploadFiles.fileProgress?.file
        const album = getState().uploadFiles.album

        if (file && album) {
            const form = new FormData()
            form.append("files", file, file.name)
            form.append("albumId", album.id.toString())
            Axios.post(uploadUrl, form, {
                onUploadProgress: (progressEvent) => {
                    console.log(progressEvent)
                },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response:AxiosResponse<MediaItem | ServiceError>) => {
                console.log(response)
                const data = response.data
                if("error" in data){
                    console.error(data)
                }else{
                    dispatch({type: FILE_UPLOADED, item: data})
                }

                dispatch(doFilesUpload(getState().uploadFiles.files, album))
            }).catch(e => {
                console.error(e)
                dispatch(doFilesUpload(getState().uploadFiles.files, album))
            })
        }
    }

}